"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Container = _interopRequireDefault(require("../components/Container"));

var _Text = _interopRequireDefault(require("../components/Text"));

var _Link = _interopRequireDefault(require("../components/Link"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ArticleListWrapper = (0, _styled["default"])('div')(function (_ref) {
  var theme = _ref.theme;
  return {
    label: 'ArticleListContainer',
    paddingTop: '30px',
    paddingBottom: '30px',
    backgroundColor: theme.colors.white,
    color: theme.colors.text
  };
});
var WrapperContainer = (0, _styled["default"])(_Container["default"])(function (_ref2) {
  var theme = _ref2.theme;
  return _defineProperty({
    label: 'WrapperContainer'
  }, theme.media.tablet, {
    width: '768px'
  });
});
var Articles = (0, _styled["default"])('div')({
  label: 'Articles'
});
var ShortArticleWrapper = (0, _styled["default"])(_Link["default"])(function (_ref4) {
  var theme = _ref4.theme;
  return _defineProperty({
    display: 'block',
    label: 'ShortArticle',
    padding: '30px 0',
    borderBottom: "1px solid ".concat(theme.colors.lightGray),
    ':last-child': {
      borderBottom: '0'
    }
  }, theme.media.tablet, {
    padding: '40px 0'
  });
});
var ShortArticleContainer = (0, _styled["default"])('div')({
  transform: 'translateY(0)',
  transition: 'transform 0.2s',
  ':hover': {
    transform: 'translateY(-5px)'
  }
});
var StyledText = (0, _styled["default"])(_Text["default"])({
  marginTop: '30px',
  marginBottom: '30px'
});

var ArticleList =
/*#__PURE__*/
function (_Component) {
  _inherits(ArticleList, _Component);

  function ArticleList() {
    _classCallCheck(this, ArticleList);

    return _possibleConstructorReturn(this, _getPrototypeOf(ArticleList).apply(this, arguments));
  }

  _createClass(ArticleList, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          items = _this$props.items;
      return _react["default"].createElement(ArticleListWrapper, null, title && _react["default"].createElement(_Container["default"], null, _react["default"].createElement(StyledText, {
        size: "typo1"
      }, title)), _react["default"].createElement(WrapperContainer, null, _react["default"].createElement(Articles, null, items && items.map(function (item, i) {
        return _react["default"].createElement(ShortArticle, {
          key: i,
          date: item.date,
          title: item.title,
          category: item.category,
          link: item.link
        });
      }))));
    }
  }]);

  return ArticleList;
}(_react.Component);

var ArticleDate = (0, _styled["default"])(_Text["default"])(function (_ref6) {
  var theme = _ref6.theme;
  return _defineProperty({
    label: 'ArticleDate',
    textTransform: 'uppercase',
    marginBottom: '15px'
  }, theme.media.tablet, {
    "float": 'left',
    width: '130px'
  });
});
var ArticleTitle = (0, _styled["default"])(_Text["default"])({
  label: 'ArticleTitle',
  marginBottom: '10px'
});
var ArticleCategory = (0, _styled["default"])(_Text["default"])(function (_ref8) {
  var theme = _ref8.theme;
  return {
    label: 'ArticleCategory',
    color: theme.colors.darkGray,
    textTransform: 'uppercase',
    marginBottom: 0
  };
});
var ArticleMain = (0, _styled["default"])('div')(function (_ref9) {
  var _ref10;

  var theme = _ref9.theme;
  return _ref10 = {
    label: 'ArticleMain'
  }, _defineProperty(_ref10, theme.media.tablet, {
    marginLeft: '160px'
  }), _defineProperty(_ref10, theme.media.desktop, {
    marginLeft: '200px'
  }), _ref10;
});

var ShortArticle = function ShortArticle(_ref11) {
  var date = _ref11.date,
      title = _ref11.title,
      category = _ref11.category,
      link = _ref11.link;
  return _react["default"].createElement(ShortArticleWrapper, {
    href: link.url
  }, _react["default"].createElement(ShortArticleContainer, null, _react["default"].createElement(ArticleDate, null, date), _react["default"].createElement(ArticleMain, null, _react["default"].createElement(ArticleTitle, {
    size: "typo3"
  }, title), category && _react["default"].createElement(ArticleCategory, {
    size: "typo6"
  }, category))));
};

var _default = ArticleList;
exports["default"] = _default;